import { useEffect, useRef } from "react";
var usePoller = function (fn, delay) {
    var savedCallback = useRef();
    // Remember the latest fn.
    useEffect(function () {
        savedCallback.current = fn;
    }, [fn]);
    // Set up the interval.
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        function tick() {
            if (savedCallback.current)
                savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [delay]);
    // run at start too
    useEffect(function () {
        fn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
export default usePoller;
